import {Injectable} from "@angular/core";
import {BehaviorSubject, Subject} from "rxjs";
import {Aditivo} from "../model/Aditivo";

@Injectable({
  providedIn: 'root'
})
export class PesquisaAditivoStateService {

  initialState: PesquisaAditivoState = {
    exibePesquisaAvancada: false,
    criterio: "",
    aditivos: [],
  }

  state: Subject<PesquisaAditivoState> = new BehaviorSubject<PesquisaAditivoState>(this.initialState);

  state$ = this.state.asObservable();

  update(newState: PesquisaAditivoState) {
    this.state.next(newState);
  }
}

export interface PesquisaAditivoState {

  exibePesquisaAvancada: boolean;
  aditivos: Aditivo[];

  // Critério básico
  criterio?: string;
  // Critérios Avançados
  instituicaoFinanceira?: string;
  criterioDatProtocoloInicio?: Date;
  criterioDatProtocoloFim?: Date;
  criterioSituacao?: string;
  criterioFase?: string;
  criterioProposta?: string;
  criterioAno?: number;
  criterioPac?: string;
  criterioComprador?: string;

}
